import { render, staticRenderFns } from "./user-card-dialog.vue?vue&type=template&id=46f9eb50&scoped=true&"
import script from "./user-card-dialog.vue?vue&type=script&lang=js&"
export * from "./user-card-dialog.vue?vue&type=script&lang=js&"
import style0 from "./user-card-dialog.vue?vue&type=style&index=0&id=46f9eb50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f9eb50",
  null
  
)

export default component.exports